import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  useToast,
  Text,
  SimpleGrid,
  Spinner,
  InputGroup,
  InputLeftElement,
  UnorderedList,
  ListItem,
  CloseButton,
} from '@chakra-ui/react';
import {
  AddIcon,
  EditIcon,
  SearchIcon,
  ArrowUpIcon,
  DownloadIcon,
} from '@chakra-ui/icons';
import Select from 'react-select';
import axios from 'axios';
import DevelopmentTable from './tables/DevelopmentTable';
import baseUrl from 'Base_Url/baseUrl';
import { HStack } from '@chakra-ui/react';
import {
  Avatar,
  Icon,
  Divider,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
} from '@chakra-ui/react';
import { EmailIcon, PhoneIcon } from '@chakra-ui/icons';
import { FaUserAlt, FaIdBadge, FaBuilding, FaUserEdit } from 'react-icons/fa';
import { MdDevices } from 'react-icons/md';
import { Switch } from '@chakra-ui/react';
import { useColorModeValue } from '@chakra-ui/react';
import AddUserModal from './AddUserModal';
import EditUserModal from './UpdateUserModal';
import ViewUserModal from './ViewUserModal';
import { debounce } from 'lodash';
import { useSearchParams } from 'react-router-dom';
import { Wrap, WrapItem } from '@chakra-ui/react';
import axiosInstance from 'axiosInstance';
import Swal from 'sweetalert2';
import { HiMiniUsers } from 'react-icons/hi2';
const User = () => {
  const [users, setUsers] = useState([]);
  const [addUser, setAddUser] = useState({
    name: '',
    phoneNo: '',
    role: '',
    gender: '',
    division: '',
    district: '',
    tahsil: '',
    village: [],
  });
  const [division, setDivision] = useState(null);
  const [district, setDistrict] = useState(null);
  const [tahsil, setTahsil] = useState(null);
  const [villages, setVillages] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('token');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();
  const [viewUser, setViewUser] = useState(null);
  const [uploadFile, setUploadFile] = useState(null);
  const {
    isOpen: isViewOpen,
    onOpen: onViewOpen,
    onClose: onViewClose,
  } = useDisclosure();
  const [editUser, setEditUser] = useState(null);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const bgColor = useColorModeValue('white', 'gray.700');
  const [search, setSearch] = useState(() => searchParams.get('search') || '');
  const addmodalheaderBg = useColorModeValue(
    'linear-gradient(90deg,rgb(34, 84, 157) 0%,rgb(60, 129, 159) 50%,rgb(93, 153, 156) 100%)',
    'linear-gradient(90deg,rgb(39, 205, 230) 0%,rgb(81, 198, 224) 50%,rgb(136, 218, 236) 100%)',
  );
  const textColor = useColorModeValue('secondaryGray.900', 'white');

  const roleHierarchy = {
    admin: [
      { value: 'division', label: 'Divisional' },
      { value: 'collector', label: 'Collector' },
      { value: 'tahsildar', label: 'Tahsildar' },
      { value: 'talati', label: 'Talati' },
    ],
    division: [
      { value: 'collector', label: 'Collector' },
      { value: 'tahsildar', label: 'Tahsildar' },
      { value: 'talati', label: 'Talati' },
    ],
    collector: [
      { value: 'tahsildar', label: 'Tahsildar' },
      { value: 'talati', label: 'Talati' },
    ],
    tahsildar: [{ value: 'talati', label: 'Talati' }],
    talati: [],
  };

  const currentUserRole = useMemo(() => {
    return JSON.parse(localStorage.getItem('user'))?.role || 'admin';
  }, []);

  const roleOptions = useMemo(() => {
    return [
      { value: '', label: 'Select Role' },
      ...(roleHierarchy[currentUserRole] || []),
    ];
  }, [currentUserRole]);

  const debouncedSearch = useMemo(
    () =>
      debounce((val) => {
        setSearch(val);
        setPage(1);
        const newParams = new URLSearchParams(searchParams);
        if (val) {
          newParams.set('search', val);
        } else {
          newParams.delete('search');
        }

        newParams.set('page', 1);

        setSearchParams(newParams);
      }, 500),
    [searchParams, setSearchParams],
  );

  useEffect(() => {
    return () => debouncedSearch.cancel();
  }, [debouncedSearch]);

  const openEditModal = (user) => {
    setEditUser({
      ...user,
      division: user.division?._id || user.division || '',
      district: user.district?._id || user.district || '',
      tahsil: user.tahsil?._id || user.tahsil || '',
      village: Array.isArray(user.village)
        ? user.village.map((v) => (typeof v === 'object' ? v._id : v))
        : user.village
        ? [typeof user.village === 'object' ? user.village._id : user.village]
        : [],
      active: user.active !== undefined ? user.active : true,
    });
    setIsEditOpen(true);
  };

  const closeEditModal = () => {
    setEditUser(null);
    setIsEditOpen(false);
  };

  const handleRowClick = (user) => {
    setViewUser(user);
    onViewOpen();
  };

  const {
    isOpen: isUploadOpen,
    onOpen: onUploadOpen,
    onClose: onUploadClose,
  } = useDisclosure();

  useEffect(() => {
    getUsers(searchParams.get('search') || '');
  }, [page, searchParams]);

  useEffect(() => {
    const pageParam = parseInt(searchParams.get('page'), 10);
    if (pageParam && !isNaN(pageParam)) {
      setPage(pageParam);
    }
  }, [searchParams]);

  const fetchAllRegions = async (search = '', page = 1, limit = 10) => {
    try {
      const [divRes, distRes, tahsilRes, villageRes] = await Promise.all([
        axiosInstance.get(`${baseUrl}/master/all-divisions`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { search },
        }),
        axios.get(`${baseUrl}/master/all-districts`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { search, page, limit },
        }),
        axios.get(`${baseUrl}/master/all-tahsils`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { search, page, limit },
        }),
        axios.get(`${baseUrl}/master/all-villages`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { search, page, limit },
        }),
      ]);
      console.log(divRes.data?.data?.data, 'divRes');
      setDivision(divRes.data?.data?.data || null);
      setDistrict(distRes.data?.data?.data || []);
      setTahsil(tahsilRes.data?.data?.data || null);
      setVillages(
        Array.isArray(villageRes.data?.data?.data)
          ? villageRes.data?.data?.data
          : [],
      );
    } catch (e) {
      toast({ title: 'Failed to load region data', status: 'error' });
    }
  };

  useEffect(() => {
    fetchAllRegions();
  }, [toast, token]);

  const getUsers = async (searchString = '') => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${baseUrl}/auth/users?page=${page}&searchString=${encodeURIComponent(
          searchString,
        )}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      setUsers(res.data.data.data || []);
      setTotalPages(res.data.data.totalPages || 1);
    } catch (e) {
      toast({ title: 'Failed to load users', status: 'error' });
    }
    setLoading(false);
  };

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const pageFromURL = parseInt(query.get('page')) || 1;
    setPage(pageFromURL);
  }, []);

  const handleAddUser = useCallback(async () => {
    setLoading(true);
    try {
      const payload = {
        name: addUser.name,
        phoneNo: addUser.phoneNo,
        role: addUser?.role,
        gender: addUser.gender,
      };
      if (addUser.division) payload.division = addUser.division;
      if (addUser.district) payload.district = addUser.district;
      if (addUser.tahsil) payload.tahsil = addUser.tahsil;
      if (addUser.village.length) payload.village = addUser.village;

      await axios.post(`${baseUrl}/auth/register`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast({ title: 'User added', status: 'success' });
      onClose();
      setAddUser({
        name: '',
        phoneNo: '',
        role: '',
        gender: '',
        division: '',
        district: '',
        tahsil: '',
        village: [],
      });
      getUsers();
    } catch (e) {
      toast({
        title: e.response?.data?.data || 'Failed to add user',
        status: 'error',
      });
    }
    setLoading(false);
  }, [addUser, token, toast, onClose]);

  const handleBulkUpload = async () => {
    if (!uploadFile) return;
    setLoading(true);

    const formData = new FormData();
    formData.append('file', uploadFile);

    try {
      const response = await axios.post(
        `${baseUrl}/auth/upload-bulk-user`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      if (response) {
        const result = response.data?.data;
        const message = result?.message || 'Bulk upload completed.';

        Swal.fire({
          title:
            result.errorDetails?.length > 0
              ? 'Uploaded with Warnings'
              : 'Upload Successful',
          html: `
          <div style="text-align:left;">
            <strong>${message}</strong>
            ${
              result.errorDetails?.length > 0
                ? `<ul style="margin-top:10px; max-height:120px; overflow-y:auto; padding-left:16px;">
                    ${result.errorDetails
                      .map((err) => `<li>${err}</li>`)
                      .join('')}
                   </ul>`
                : ''
            }
          </div>
        `,
          icon: result.errorDetails?.length > 0 ? 'warning' : 'success',
          width: 600,
          confirmButtonColor: '#3182ce',
        });

        onUploadClose();
        setUploadFile(null);
        getUsers();
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.data ||
        err?.response?.data?.message ||
        'Unknown error occurred during upload.';

      Swal.fire({
        title: 'Bulk Upload Failed',
        text: errorMessage,
        icon: 'error',
        confirmButtonColor: '#e53e3e',
      });
    } finally {
      setLoading(false);
    }
  };

  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadFormat = async () => {
    setIsDownloading(true);
    try {
      const res = await axios.get(`${baseUrl}/auth/download-xlsx`, {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${token}` },
      });

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Bulk-User-Format.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      Swal.fire({
        title: 'Downloaded!',
        text: 'Bulk upload format has been downloaded successfully.',
        icon: 'success',
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (err) {
      Swal.fire({
        title: 'Download Failed',
        text: 'Unable to download the bulk upload format file.',
        icon: 'error',
        confirmButtonColor: '#e53e3e',
      });
    } finally {
      setIsDownloading(false);
    }
  };
  const handlePageChange = (newPage) => {
    setPage(newPage);
    const newParams = new URLSearchParams(searchParams);
    newParams.set('page', newPage);
    setSearchParams(newParams);
  };

  useEffect(() => {
    console.log(district);
  }, [district]);

  const fetchDistrictsByDivision = async (divisionId) => {
    try {
      const res = await axios.get(`${baseUrl}/master/all-districts`, {
        params: { divisionId },
        headers: { Authorization: `Bearer ${token}` },
      });
      setDistrict(res?.data?.data?.data || null);
    } catch {
      toast({ title: 'Failed to load district', status: 'error' });
    }
  };

  const fetchTahsilsByDistrict = async (districtId) => {
    try {
      const res = await axios.get(`${baseUrl}/master/all-tahsils`, {
        params: { districtId },
        headers: { Authorization: `Bearer ${token}` },
      });
      setTahsil(res?.data?.data?.data || null);
    } catch {
      toast({ title: 'Failed to load tahsil', status: 'error' });
    }
  };

  const fetchVillagesByTahsil = async (tahsilId) => {
    try {
      const res = await axios.get(`${baseUrl}/master/all-villages`, {
        params: { tahsilId },
        headers: { Authorization: `Bearer ${token}` },
      });
      setVillages(
        Array.isArray(res.data?.data?.data) ? res.data?.data?.data : [],
      );
    } catch {
      toast({ title: 'Failed to load villages', status: 'error' });
    }
  };

  const mappedDivisions = useMemo(
    () =>
      Array.isArray(division)
        ? division.map((d) => ({ value: d._id, label: d.name }))
        : [],
    [division],
  );

  const mappedDistricts = useMemo(
    () =>
      Array.isArray(district)
        ? district.map((d) => ({ value: d._id, label: d.name }))
        : [],
    [district],
  );

  const mappedTahsils = useMemo(
    () =>
      Array.isArray(tahsil)
        ? tahsil.map((t) => ({ value: t._id, label: t.name }))
        : [],
    [tahsil],
  );

  const mappedVillages = useMemo(
    () =>
      Array.isArray(villages)
        ? villages.map((v) => ({ value: v._id, label: v.name }))
        : [],
    [villages],
  );

  const menuBg = useColorModeValue('white', '#1A202C');
  const multiBg = useColorModeValue('#BEE3F8', '#4A5568');
  const inputTextColor = useColorModeValue('gray.800', 'white');
  const placeholderColor = useColorModeValue('gray.500', 'gray.400');

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: bgColor,
      color: textColor,
      borderColor: state.isFocused ? '#3182ce' : base.borderColor,
      boxShadow: state.isFocused ? '0 0 0 1px #3182ce' : base.boxShadow,
      '&:hover': {
        borderColor: '#3182ce',
      },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: menuBg,
      color: textColor,
    }),
    singleValue: (base) => ({
      ...base,
      color: textColor,
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: multiBg,
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: textColor,
    }),
    placeholder: (base) => ({
      ...base,
      color: placeholderColor,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  const renderRegionSelectors = (userObjParam, setUserObj = setAddUser) => {
    const userObj = userObjParam ?? addUser;
    if (!userObj) return null;

    const getValue = (options, selectedIds) =>
      Array.isArray(selectedIds)
        ? options.filter((opt) => selectedIds.includes(opt.value))
        : [];

    const DivisionSelect = (
      <FormControl isRequired>
        <FormLabel>Division</FormLabel>
        <Select
          options={mappedDivisions}
          onChange={(opt) => {
            const divisionId = opt?.value || '';
            setUserObj({
              ...userObj,
              division: divisionId,
              district: '',
              tahsil: '',
              village: [],
            });
            if (divisionId) fetchDistrictsByDivision(divisionId);
            setTahsil(null);
            setDistrict(mappedDistricts);
            setVillages([]);
          }}
          styles={selectStyles}
          value={getValue(mappedDivisions, [userObj.division])[0] || null}
          placeholder="Select Division"
          menuPortalTarget={document.body}
          menuPosition="fixed"
        />
      </FormControl>
    );

    const DistrictSelect = (
      <FormControl isRequired>
        <FormLabel>District</FormLabel>
        <Select
          options={mappedDistricts}
          styles={selectStyles}
          onChange={(opt) => {
            const districtId = opt?.value || '';
            setUserObj({
              ...userObj,
              district: districtId,
              tahsil: '',
              village: [],
            });
            if (districtId) fetchTahsilsByDistrict(districtId);
            setVillages([]);
          }}
          value={getValue(mappedDistricts, [userObj.district])[0] || null}
          placeholder="Select District"
          isDisabled={!addUser.division}
          menuPortalTarget={document.body}
          menuPosition="fixed"
        />
      </FormControl>
    );

    const TahsilSelect = (
      <FormControl isRequired>
        <FormLabel>Tahsil</FormLabel>
        <Select
          options={mappedTahsils}
          styles={selectStyles}
          onChange={(opt) => {
            const tahsilId = opt?.value || '';
            setUserObj({ ...userObj, tahsil: tahsilId, village: [] });
            if (tahsilId) fetchVillagesByTahsil(tahsilId);
          }}
          value={getValue(mappedTahsils, [userObj.tahsil])[0] || null}
          placeholder="Select Tahsil"
          isDisabled={!addUser.district}
          menuPortalTarget={document.body}
          menuPosition="fixed"
        />
      </FormControl>
    );

    const VillageSelect = (
      <FormControl isRequired>
        <FormLabel>Village</FormLabel>
        <Select
          isMulti
          styles={selectStyles}
          options={mappedVillages}
          onChange={(selectedOptions) =>
            setUserObj({
              ...userObj,
              village: selectedOptions
                ? selectedOptions.map((opt) => opt.value)
                : [],
            })
          }
          value={getValue(mappedVillages, userObj.village)}
          placeholder="Select Villages"
          isDisabled={!addUser.tahsil}
          menuPortalTarget={document.body}
          menuPosition="fixed"
        />
      </FormControl>
    );

    switch (userObj?.role) {
      case 'division':
        return <>{DivisionSelect}</>;
      case 'collector':
        return (
          <>
            {DivisionSelect}
            {DistrictSelect}
          </>
        );
      case 'tahsildar':
        return (
          <>
            {DivisionSelect}
            {DistrictSelect}
            {TahsilSelect}
          </>
        );
      case 'talati':
        return (
          <>
            {DivisionSelect}
            {DistrictSelect}
            {TahsilSelect}
            {VillageSelect}
          </>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if (!isOpen) {
      setAddUser({
        name: '',
        phoneNo: '',
        role: '',
        gender: '',
        division: '',
        district: '',
        tahsil: '',
        village: [],
      });
    }
  }, [isOpen]);

  return (
    <>
      <Box
        pt={{ base: '140px', md: '90px', xl: '90px', sm: '100px' }}
        px={{ base: '4', md: '8' }}
      >
        <Flex px="20px" mb="8px" justifyContent="space-between" align="center">
          <Flex align="center" gap={2}>
            <HiMiniUsers size={20} color="#4B80DE" />
            <Text color={textColor} fontSize="22px" fontWeight="bold">
              Users
            </Text>
          </Flex>
        </Flex>

        <Flex
          direction={{ base: 'column', md: 'row' }}
          justify={{ base: 'flex-start', md: 'space-between' }}
          align={{ base: 'stretch', md: 'center' }}
          wrap="wrap"
          gap={4}
          mb={4}
        >
          <InputGroup size="sm" width={{ base: '100%', sm: '300px' }}>
            <InputLeftElement pointerEvents="none">
              <SearchIcon color="gray.400" />
            </InputLeftElement>
            <Input
              bg={bgColor}
              color={inputTextColor}
              _placeholder={{ color: placeholderColor }}
              placeholder="Search by name, phone, region..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                debouncedSearch(e.target.value);
                setPage(1);
              }}
            />
          </InputGroup>

          <Wrap spacing={3} justify={{ base: 'flex-start', md: 'flex-end' }}>
            <WrapItem>
              <Button
                size="sm"
                leftIcon={<AddIcon />}
                colorScheme="blue"
                onClick={onOpen}
                width={{ base: '100%', sm: 'auto' }}
              >
                Add User
              </Button>
            </WrapItem>

            <WrapItem>
              <Button
                size="sm"
                leftIcon={<DownloadIcon />}
                colorScheme="purple"
                onClick={handleDownloadFormat}
                isLoading={isDownloading}
                loadingText="Downloading"
                width={{ base: '100%', sm: 'auto' }}
              >
                Download Format
              </Button>
            </WrapItem>

            <WrapItem>
              <Button
                size="sm"
                leftIcon={<ArrowUpIcon />}
                colorScheme="teal"
                onClick={onUploadOpen}
                width={{ base: '100%', sm: 'auto' }}
              >
                Upload Bulk Users
              </Button>
            </WrapItem>
          </Wrap>
        </Flex>

        {loading ? (
          <Spinner />
        ) : (
          <DevelopmentTable
            tableData={users}
            handleEditUser={openEditModal}
            handleDeleteUser={() => {}}
            handlePageChange={handlePageChange}
            handleRowClick={handleRowClick}
            page={page}
            totalPages={totalPages}
            loading={loading}
          />
        )}

        <AddUserModal
          isOpen={isOpen}
          onClose={onClose}
          addUser={addUser}
          setAddUser={setAddUser}
          handleAddUser={handleAddUser}
          loading={loading}
          roleOptions={roleOptions}
          renderRegionSelectors={renderRegionSelectors}
        />

        <EditUserModal
          isOpen={isEditOpen}
          onClose={closeEditModal}
          editUser={editUser}
          setEditUser={setEditUser}
          roleOptions={roleOptions}
          renderRegionSelectors={renderRegionSelectors}
          token={token}
          getUsers={getUsers}
        />

        <ViewUserModal
          isOpen={isViewOpen}
          onClose={onViewClose}
          viewUser={viewUser}
        />

        <Modal
          isOpen={isUploadOpen}
          onClose={onUploadClose}
          size="md"
          isCentered
        >
          <ModalOverlay />
          <ModalContent borderRadius="lg" overflow="hidden">
            <ModalHeader bg="blue.600" color="white" py={3}>
              Upload Bulk Users
            </ModalHeader>
            <ModalCloseButton color="white" />
            <ModalBody py={6} px={4}>
              <FormControl>
                <FormLabel fontWeight="semibold" color="gray.700">
                  Select Excel/CSV File
                </FormLabel>
                <Box
                  borderWidth="2px"
                  borderStyle="dashed"
                  borderColor="gray.300"
                  borderRadius="md"
                  p={6}
                  textAlign="center"
                  cursor="pointer"
                  _hover={{ bg: 'gray.50' }}
                  onClick={() =>
                    document.getElementById('bulk-upload-input').click()
                  }
                >
                  <Input
                    id="bulk-upload-input"
                    type="file"
                    hidden
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    onChange={(e) => setUploadFile(e.target.files[0])}
                  />
                  <ArrowUpIcon w={6} h={6} color="gray.500" mb={2} />
                  <Text fontSize="sm" color="gray.500">
                    Click to select a file or drag and drop here
                  </Text>
                  {uploadFile && (
                    <Text
                      mt={2}
                      color="green.600"
                      fontWeight="medium"
                      fontSize="sm"
                    >
                      Selected: {uploadFile.name}
                    </Text>
                  )}
                </Box>
              </FormControl>
            </ModalBody>
            <ModalFooter bg="gray.50">
              <Button variant="ghost" mr={3} onClick={onUploadClose}>
                Cancel
              </Button>
              <Button
                colorScheme="teal"
                onClick={handleBulkUpload}
                isDisabled={!uploadFile}
                isLoading={loading}
              >
                Upload
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Box>
    </>
  );
};

export default User;
